import { IntegrationType } from '../types';
import * as React from 'react';
import { AppBuildComponent, CIBuildComponent } from './BuildComponents';
import Space from 'antd/lib/space';
import LinkageIcon from './icons/LinkageIcon';
interface CIAppStoreBuildComponentProps {
    ciBuildIdentifier: string;
    ciBuildIntegrationId: IntegrationType;
    appStoreBuildIdentifier?: string;
    appStoreBuildIntegrationId?: IntegrationType;
    isAppStoreBuildProcessed: boolean;
}

const CIAppStoreBuildComponent: React.FC<CIAppStoreBuildComponentProps> = (props: CIAppStoreBuildComponentProps) => {
    const ciBuildComponent = (
        <CIBuildComponent integrationId={props.ciBuildIntegrationId} buildIdentifier={props.ciBuildIdentifier} strong />
    );
    let appStoreBuildComponent = null;

    if (props.appStoreBuildIdentifier && props.appStoreBuildIntegrationId) {
        appStoreBuildComponent = (
            <AppBuildComponent
                integrationId={props.appStoreBuildIntegrationId}
                buildIdentifier={props.appStoreBuildIdentifier}
                strong
                isProcessed={props.isAppStoreBuildProcessed}
            />
        );
    }

    return (
        <Space align="center">
            {ciBuildComponent}
            {appStoreBuildComponent && ciBuildComponent && <LinkageIcon width={16} height={16} />}
            {appStoreBuildComponent}
        </Space>
    );
};

export default CIAppStoreBuildComponent;
